module.exports = __webpack_public_path__ + "img/birth_bg.d019c74c.jpg";